import styled from "styled-components";

export const DetailedDescription = styled.p`
    position: relative;
    font-size: 1.1em;
    color: ${({ theme }) => theme.darkBlue};
    line-height: 1.8em;
    text-align: justify;
`;
